import { Typography } from "@mui/material";

export const isCharacterLimitReached = (
  value: string | undefined,
  maxLength: number
): boolean => (value?.length ?? 0) >= maxLength;

type CharacterCounterProps = {
  value?: string;
  maxLength: number;
};

const CharacterCounter = ({
  value,
  maxLength,
}: CharacterCounterProps): JSX.Element => {
  const count = value?.length ?? 0;
  const limitReached = isCharacterLimitReached(value, maxLength);

  return (
    <Typography
      variant="caption"
      sx={{
        display: "block",
        textAlign: "right",
        mt: 0.5,
        color: limitReached ? "error.main" : "text.secondary",
        fontWeight: limitReached ? 600 : 400,
      }}
    >
      {count}/{maxLength} characters
    </Typography>
  );
};

export default CharacterCounter;
